/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.models {
    import DataOperationType = Wars.Domain.Model.Codes.Enums.DataOperationType;

    export class DataOperation extends BaseEntity implements Wars.Domain.Model.DataOperation{
        constructor() {
            super();
        }

        dataSource_id: string;
        description: string;
        myDataSource: Wars.Domain.Model.DataSource;
        operationType: DataOperationType;
        parameters: Wars.Domain.Model.DataOperationParameter[];
        responseExample: string;
        url: string;
        private json:any = null;
        public jsonView(): any {
            if (!this.json && this.responseExample) {
                this.json = JSON.parse(this.responseExample);
            }

            return this.json;
        }

        name: string;
        isArrayResult: boolean;
        objectSchema_id: string;
        resultSchema: Wars.Domain.Model.ObjectSchema;
        isTested: boolean;
    }
}